import app from '../../forum/app';
import Component from '../../common/Component';
import humanTime from '../../common/helpers/humanTime';
import fullTime from '../../common/helpers/fullTime';
import IPAddress from '../../common/components/IPAddress';
import Post from '../../common/models/Post';
import classList from '../../common/utils/classList';
import ItemList from '../../common/utils/ItemList';
/**
 * The `PostMeta` component displays the time of a post, and when clicked, shows
 * a dropdown containing more information about the post (number, full time,
 * permalink).
 */
export default class PostMeta extends Component {
  view() {
    return m("div", {
      className: "Dropdown PostMeta"
    }, this.viewItems().toArray());
  }
  viewItems() {
    const items = new ItemList();
    const post = this.attrs.post;
    const permalink = this.getPermalink(post);
    const time = post.createdAt();
    items.add('time', m("button", {
      type: "button",
      className: classList({
        'Button Button--text': true,
        'Dropdown-toggle Button--link': !!permalink
      }),
      onclick: permalink ? this.selectPermalink.bind(this) : undefined,
      "data-toggle": "dropdown"
    }, humanTime(time)), 100);
    items.add('meta-dropdown', !!permalink && m("div", {
      className: "Dropdown-menu dropdown-menu"
    }, this.metaItems().toArray()), 90);
    return items;
  }
  metaItems() {
    const items = new ItemList();
    const post = this.attrs.post;
    const time = post.createdAt();
    const permalink = this.getPermalink(post);
    const touch = 'ontouchstart' in document.documentElement;
    items.add('post-number', m("span", {
      className: "PostMeta-number"
    }, this.postIdentifier(post)), 100);
    items.add('post-time', m("span", {
      className: "PostMeta-time"
    }, fullTime(time)), 90);
    items.add('post-ip', m("span", {
      className: "PostMeta-ip"
    }, m(IPAddress, {
      ip: post.ipAddress?.()
    })), 80);
    items.add('permalink', touch ? m("a", {
      className: "Button PostMeta-permalink",
      href: permalink
    }, permalink) : m("input", {
      className: "FormControl PostMeta-permalink",
      value: permalink,
      onclick: e => e.stopPropagation()
    }), 0);
    return items;
  }

  /**
   * Get the permalink for the given post.
   */
  getPermalink(post) {
    if (post instanceof Post) {
      return app.forum.attribute('baseOrigin') + app.route.post(post);
    }
    return this.attrs.permalink?.() || null;
  }

  /**
   * Selects the permalink input when the dropdown is shown.
   */
  selectPermalink(e) {
    const $button = $(e.currentTarget);
    setTimeout(() => $button.parent().find('.PostMeta-permalink').select());
    e.redraw = false;
  }
  postIdentifier(post) {
    if (post instanceof Post) {
      return app.translator.trans('core.forum.post.number_tooltip', {
        number: post.number()
      }, true);
    }
    return null;
  }
}
flarum.reg.add('core', 'forum/components/PostMeta', PostMeta);